import React from 'react';

const AboutSection = () => {
  return (
    <section className="py-8 sm:py-10 lg:py-12 bg-white" id="about">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 sm:mb-8">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">About PAK School & College System</h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-4 sm:mb-6"></div>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
            Nurturing Excellence, Building Character, Shaping Futures
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          <div className="relative">
            <img src="/assets/about-image.jpg" alt="PAK School Environment" className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-2xl shadow-2xl" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-2xl flex items-end">
              <div className="p-6 sm:p-8">
                <h3 className="text-2xl sm:text-3xl font-bold text-white">27+ Years of Excellence</h3>
              </div>
            </div>
          </div>
          
          <div className="space-y-4 sm:space-y-6">
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              At PAK School and College System, we pride ourselves on providing a dynamic learning environment 
              that nurtures academic excellence and personal development. With a dedicated faculty and a commitment 
              to fostering creativity, critical thinking, and character building, we strive to empower students 
              to reach their full potential.
            </p>
            
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              Our holistic approach to education ensures a well-rounded learning experience, preparing students 
              for a future of success and positive contributions to society. We believe in creating an environment 
              where every student can thrive and discover their unique talents.
            </p>
          </div>
        </div>
    
        
        {/* Stats Section */}
        <div className="mt-12 sm:mt-16 lg:mt-20">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            <div className="text-center">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-blue-600 mb-2">27+</div>
              <div className="text-sm sm:text-base text-gray-600 font-medium">Years of Excellence</div>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-blue-600 mb-2">3</div>
              <div className="text-sm sm:text-base text-gray-600 font-medium">Campus Locations</div>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-blue-600 mb-2">1600+</div>
              <div className="text-sm sm:text-base text-gray-600 font-medium">Happy Students</div>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-blue-600 mb-2">120+</div>
              <div className="text-sm sm:text-base text-gray-600 font-medium">Expert Teachers</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
